<template>
  <CSidebar
    aside
    overlaid
    size="lg"
    colorScheme="light"
    :show="$store.state.optionGroupsAsideShow"
    @update:show="(val) => $store.commit('set', ['optionGroupsAsideShow', val])"
  >
    <div class="sidebar-content scrollable">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h5 class="mb-0">Option Groups & Options</h5>
        <CSidebarClose @click.native="$store.commit('toggle', 'optionGroupsAsideShow')" />
      </div>

      <template v-if="item">
        <h5 class="font-weight-bold mb-3">{{ item.menu_name }}</h5>
        <div v-if="item.option_groups && item.option_groups.length">
          <div v-for="(group, idx) in item.option_groups" :key="'group-' + idx" class="option-group rounded shadow-sm">
            <div class="d-flex align-items-center mb-2">
              <CIcon name="cil-list" class="mr-2 text-primary" />
              <span class="font-weight-bold">{{ group.option_group_name }}</span>
              <CBadge
                class="ml-auto"
                color="secondary"
                v-if="group.min_selections !== undefined && group.max_selections !== undefined"
              >
                Min: {{ group.min_selections }} / Max: {{ group.max_selections }}
              </CBadge>
            </div>

            <div v-for="(opt, i) in group.options" :key="'opt-' + i" class="option-item d-flex align-items-center mb-2 p-2 rounded bg-white border">
              <CIcon name="cil-check-circle" class="mr-2 text-success" />
              <span class="flex-grow-1">{{ opt.option_name }}</span>
              <span class="ml-3 text-info font-weight-bold" v-if="opt.additionPrice !== undefined && opt.additionPrice > 0">
                +{{ opt.additionPrice | toCurrency }}
              </span>
              <span class="ml-3 text-info font-weight-bold" v-else-if="opt.removePrice !== undefined && opt.removePrice > 0">
                -{{ opt.removePrice | toCurrency }}
              </span>
            </div>
          </div>
        </div>

        <div v-else class="text-muted">No option groups found.</div>
      </template>

      <template v-else>
        <div class="text-center text-muted">No menu item selected.</div>
      </template>
    </div>
  </CSidebar>
</template>

<script>
export default {
  name: 'OptionGroupsSidebar',
  props: {
    item: {
      type: Object,
      required: false
    }
  },
  computed: {
    reloadParams() {
      return [this.$store.state.optionGroupsAsideShow];
    },
  },
}
</script>

<style scoped>
.sidebar-content {
  padding: 1rem 1.5rem 0 1rem;
}
.scrollable {
  overflow-y: auto;
  height: 100%;
}

.option-group {
  background: #fafafa;
  padding: 0.375rem 0.5rem;
  margin-bottom: 1rem;
}
</style>
